<template>
    <div>
        <!-- Hvis der bliver opdelt værelser, vis liste over værelsesskift -->
        <!-- <p>Værelser deles op: {{ showSplitBookings(this.$store.getters.bookingInProgress, this.short_code) }}</p> -->
        <!-- <div class="splitRoomInfoContainer" v-if="hasSplitRooms($store.getters.bookingInProgress) > 0"> -->
        <!-- <span>bookingInProgress {{this.$store.getters.bookingInProgress}}</span><br> -->
        <!-- <p>hasSplitRooms: {{ hasSplitRooms() }}</p> -->
        <!-- <p>hasSplitRoomscomp: {{ this.totalSplits }}</p> -->
            <!-- <div class="splitRoomInfoContainer" v-if="totalSplits"> -->
            <div class="splitRoomInfoContainer" v-if="hasSplitRooms() > 0">
                <ul class="splitRoomsList">
                    <h2><span class="circle-sketch-highlight">{{ $t('opdelte_vaerelser')}}</span></h2>
                    <p class="explanation">{{ $t('opdelte_vaerelser_forklaring') }}</p>
                    <div v-for="(topArray, topKey) in showSplitBookings($store.getters.bookingInProgress)" :key="topKey">
                        <template v-if="topArray && topArray.length > 0">
                            <h3>{{ $t(topKey) }} {{ $t('opdeles_saadan') }}</h3>
                            <span v-for="(splitGroup, index) in topArray" :key="index">
                                <ul v-for="split in splitGroup" :key="split.date + '-' + split.room">
                                    <li>{{ split.date }} {{ $t('vaerelse') }}: {{ split.room }} </li>
                                </ul>
                                <hr v-if="index !== topArray.length - 1">
                            </span>
                        </template>
                    </div>
                </ul>
            </div>
        </div>
</template>
  
<script>
export default {
    props: {
        /*
        roomAvailability: {
            type: Array,
            required: true
        },
        */
        hasSplitRooms: {
            type: Function,
            required: true
        }
        /*
        short_code: {
            type: String,
            required: true
        }
        */
    },

    created() {
        //console.log('splitBooking komponent: hasSplitRooms: '+this.hasSplitRooms(this.$store.getters.bookingInProgress));
    },
    data() {
        return {
            message: '',
            roomAvailability: this.$store.getters.rooms,
        };
    },
    mounted() {
        //console.log('Split output for: '+this.short_code+' => '+JSON.stringify(this.genOutput(this.roomAvailability, this.short_code), null, 2));
        console.log('splitBooking mounted hook - hasSplitRooms: '+this.hasSplitRooms(this.$store.getters.bookingInProgress));
    },
    methods: {
        showSplitBookings(bookingInProgress, short_code = null) {
            var retVal = {};
            if(short_code === null) {
                if(typeof bookingInProgress.split === 'object') {
                    const short_codes = Object.keys(bookingInProgress.split);
                    short_codes.forEach(short_code => {
                        retVal[short_code] = retVal[short_code] || [];
                        console.log('showSplitBookings(): short_code: '+short_code);
                        bookingInProgress.split[short_code].forEach(splitOption => {
                            retVal[short_code].push(splitOption);
                            console.log('showSplitBookings(): splitOption: '+JSON.stringify(splitOption));
                        })
                    })
                }
            } else {
                for (var key in bookingInProgress['split']) {
                    console.log('showSplitBookings(): key: '+key);
                    if(key === short_code) {
                        console.log('showSplitBookings(): split output: '+JSON.stringify(bookingInProgress['split'][key]));

                        /*
                        for (const innerArray of bookingInProgress['split'][key]) {
                            for (const item of innerArray) {
                                retVal = retVal.concat(' '+iteration+': dato: '+item.date);
                                retVal = retVal.concat(' '+iteration+': vaerelse: '+item.room+'\n\n');
                            }
                            //iteration++;
                        }
                        */
                        retVal[key] = bookingInProgress['split'][key];
                        //retVal = bookingInProgress['split'][key];
                    }
                }
            }
            //return JSON.parse(retVal);
            return retVal;
        },
        genOutput(rooms, short_code) {
            var retVal = false;
            rooms.forEach(function (room) {
                if (room.short_code == short_code) {
                    if (room.split !== 0) {
                        retVal = room.split;
                    }
                }
            });
            return retVal;
        },
    }
}
</script>

<style>
.splitRoomInfoContainer {
  /* position: fixed; */
  position: sticky;
  top: 10px;
  width: 300px;
  margin: 10px auto;
  z-index: 999;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  padding: 10px 15px 10px 0px;
}

.splitRoomsList {
  list-style-type: none;
  text-align: left;
}

hr {
  width: 50%;
  margin: 10px auto; /* Centers the line horizontally */
  border: none; /* Removes the default border */
  border-top: 1px solid rgba(0, 0, 0, 0.2); /* A subtle line with transparency */
}

.explanation {
    font-style: italic;
    font-size: 0.8rem;
    line-height: 1.0;
    letter-spacing: 0.9px;
    text-transform: none;
    padding: 2px 10px 10px 10px;
}

.circle-sketch-highlight{
  position:relative;
  left:0.5em;
  /* font-family: Libre Franklin;
  font-size: 32px;
  font-weight: 500; */
}
.circle-sketch-highlight:before{
  content:"";
  z-index:-1;
  left:-0.5em;
  top:-0.1em;
  border-width:9px;
  border-style:solid;
  /* border-color:#ef8c22; */
  /* border-color:#3293c0; */
  border-color:#80c928;
  position:absolute;
  border-right-color:transparent;
  width:100%;
  height:1em;
  transform:rotate(2deg);
  opacity:0.7;
  border-radius:50%;
  padding:0.1em 0.25em;
}
.circle-sketch-highlight:after{
  content:"";
  z-index:-1;
  left:-0.5em;
  top:0.1em;
  padding:0.1em 0.25em;
  border-width:9px;
  border-style:solid;
  /* border-color:#ef8c22; */
  /* border-color:#3293c0; */
  border-color: #80c928;
  border-left-color:transparent;
  border-top-color:transparent;
  position:absolute;
  width:100%;
  height:1em;
  transform:rotate(-1deg);
  opacity:0.7;
  border-radius:50%;
}

</style>